module.exports = __webpack_public_path__ + "static/img/97-2.4453b97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/97-2.jpg
// module id = HnMP
// module chunks = 0